import React, { useEffect } from 'react';
import { LoadingPage } from '../Shared';

export function ExternalAuthResponse(): JSX.Element {
  useEffect(() => {
    window.location.assign('/authenticationReply');
  }, []);

  return <LoadingPage subtext='Signing in to the service...' fullscreen />;
}
